import type { TextureSoil } from '../types/parameters.types';

export const TEXTURE_LABELS: Record<TextureSoil, string> = {
	arenosa: 'Arenosa',
	media: 'Média',
	argilosa: 'Argilosa',
	muitoArgilosa: 'Muito Argilosa',
};

export const TEXTURE_OPTIONS: { value: TextureSoil; label: string }[] = [
	{ value: 'arenosa', label: 'Arenosa' },
	{ value: 'media', label: 'Média' },
	{ value: 'argilosa', label: 'Argilosa' },
	{ value: 'muitoArgilosa', label: 'Muito Argilosa' },
];

export const MACRONUTRIENT_CODES = ['P', 'K', 'Ca', 'Mg', 'S'];
export const MICRONUTRIENT_CODES = ['B', 'Cu', 'Fe', 'Mn', 'Zn'];
export const CHEMICAL_INDEX_CODES = [
	'MO',
	'H_Al',
	'SB',
	'CTC_ef',
	'CTC_pH7',
	'sat_Al',
	'sat_V',
	'pHagua',
];

export const PH_DOMAIN_LABELS: Record<string, string> = {
	Acidez: 'Acidez',
	Neutro: 'Neutro',
	Alcalinidade: 'Alcalinidade',
};
